import React from 'react';
import { Box, Typography, Container, Grid, Skeleton, Stack, Chip } from '@mui/material';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/productDetailCard.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { useSelector } from 'react-redux';

import { normalizeContent } from '../../../hooks/utilsFn/utilsFn';
import ProductDetailPara from '../../../mobile/mobileComponents/mobileProductDetails/ProductDetailPara';

const ProductDetailCard = ({ pageLoading }) => {
  const PRODUCTDETAILS = useSelector((state) => state?.ProductDetail?.allData);

  const settings = {
    dots: false,
    lazyLoad: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
  };

  const productDiscount = (discountKey, discount) => {
    return (
      <Chip
        label={`${discountKey || 'Discount'} : ${discount}%`}
        sx={{
          fontSize: { xs: '.7rem', sm: '1rem' },
          fontWeight: 500,
          color: 'white.main',
          backgroundColor: 'primary.main',
        }}
      />
    );
  };

  const isStoreRedeem = (redeem) => {
    if (redeem) {
      return (
        <Chip
          key={'storeTrue'}
          icon={
            <CheckCircleIcon
              sx={{
                color: '#2ab638 !important',
              }}
            />
          }
          label="Store"
          variant="filled"
          sx={{
            color: '#0fab22',
            backgroundColor: '#caf6be',
            fontSize: { lg: '1rem' },
            fontWeight: { lg: 500 },
          }}
        />
      );
    } else {
      return (
        <Chip
          icon={
            <CancelIcon
              sx={{
                color: '#ea0c0c !important',
              }}
            />
          }
          label="Store"
          variant="filled"
          sx={{
            color: '#ff2121',
            backgroundColor: '#f6bebe',
            fontSize: { lg: '1rem' },
            fontWeight: { lg: 500 },
          }}
        />
      );
    }
  };

  const isOnlineRedeem = (redeem) => {
    if (redeem) {
      return (
        <Chip
          icon={
            <CheckCircleIcon
              sx={{
                color: '#2ab638 !important',
              }}
            />
          }
          label="Online"
          variant="filled"
          sx={{
            color: '#0fab22',
            backgroundColor: '#caf6be',
            fontSize: { lg: '1rem' },
            fontWeight: { lg: 500 },
          }}
        />
      );
    } else {
      return (
        <Chip
          icon={
            <CancelIcon
              sx={{
                color: '#ea0c0c !important',
              }}
            />
          }
          label="Online"
          variant="filled"
          sx={{
            color: '#ff2121',
            backgroundColor: '#f6bebe',
            fontSize: { lg: '1rem' },
            fontWeight: { lg: 500 },
          }}
        />
      );
    }
  };

  return (
    <Container
      maxWidth="xl"
      className="product_detail_mcontainer"
      sx={{
        px: { xs: 1, sm: 0 },
        backgroundColor: 'transparent',
      }}
    >
      <Box sx={{ position: 'relative' }}>
        <Grid
          container
          sx={{
            justifyContent: { xs: 'flex-start', sm: 'center' },
            minHeight: { xs: '230px', sm: '240px', lg: 170 },
            pt: { xs: 0, sm: 3, md: 2, lg: 2 },
            pb: { xs: 0, sm: '1.5rem', lg: 0 },
            px: { xs: 0, sm: '1.5rem' },
          }}
        >
          {/* IMAGE */}
          <Grid
            item
            xs={12}
            md={5}
            lg={5}
            sx={{ px: { xs: 1 }, mb: { xs: 3, lg: 0 }, display: 'flex', justifyContent: 'center' }}
          >
            <Box sx={{ width: '100%', maxWidth: '300px', position: 'relative' }}>
              {!pageLoading ? (
                <Slider {...settings} arrows={true}>
                  {PRODUCTDETAILS?.Product_Sliders?.length > 0
                    ? PRODUCTDETAILS?.Product_Sliders?.map((item) => (
                        <Box
                          key={item?.id}
                          sx={{
                            minWidth: '280px',
                            height: { xs: '180px', sm: '200px', lg: '200px' },
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9,
                          }}
                        >
                          <Box
                            component="img"
                            src={item?.img}
                            alt={item?.title}
                            sx={{
                              width: '100%',
                              height: { xs: '180px', sm: '200px', lg: '200px' },
                              objectFit: 'contain',
                              borderRadius: { xs: 1, sm: 2 },
                              zIndex: 9,
                            }}
                          />
                        </Box>
                      ))
                    : [0, 1, 2].map((_, index) => (
                        <Box
                          key={index}
                          sx={{
                            minWidth: '280px',
                            height: { xs: '180px', sm: '200px', lg: '200px' },
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9,
                          }}
                        >
                          <Box
                            component="img"
                            src={PRODUCTDETAILS?.image}
                            alt={PRODUCTDETAILS?.title}
                            sx={{
                              width: '100%',
                              height: { xs: '180px', sm: '200px', lg: '200px' },
                              objectFit: 'contain',
                              borderRadius: { xs: 1, sm: 2 },
                              zIndex: 9,
                            }}
                          />
                        </Box>
                      ))}
                </Slider>
              ) : (
                <Skeleton variant="rounded" animation="wave" width="100%" height="280px" />
              )}
            </Box>
          </Grid>

          {/* DETAILS */}
          <Grid
            item
            xs={12}
            md={7}
            lg={7}
            sx={{
              pt: { xs: '5px', sm: 1 },
              pb: { xs: '5px', sm: '20px' },
              px: { xs: '10px', sm: '20px' },
            }}
          >
            {!pageLoading ? (
              <>
                <Typography
                  variant="h1"
                  gutterBottom
                  sx={{
                    fontSize: { sm: '1.5rem', lg: '1.5rem' },
                    color: 'primary.main',
                    fontWeight: 500,
                    textAlign: { sm: 'center', md: 'left' },
                  }}
                >
                  {PRODUCTDETAILS?.title}
                </Typography>

                <Stack
                  direction="row"
                  spacing={1}
                  sx={{
                    mt: { xs: 2, sm: 2, lg: 1 },
                    py: { lg: '4px' },
                    justifyContent: { sm: 'center', md: 'flex-start' },
                  }}
                >
                  {PRODUCTDETAILS &&
                    productDiscount(PRODUCTDETAILS.productType, PRODUCTDETAILS.discount)}
                  {PRODUCTDETAILS && isStoreRedeem(PRODUCTDETAILS?.store)}
                  {PRODUCTDETAILS && isOnlineRedeem(PRODUCTDETAILS?.website)}
                </Stack>

                <ProductDetailPara
                  productDescription={normalizeContent(PRODUCTDETAILS?.description)}
                />
              </>
            ) : (
              <Skeleton variant="text" animation="wave" sx={{ width: '100%', height: '60px' }} />
            )}
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default ProductDetailCard;
